import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { map, of } from 'rxjs';

import { MpsUserService } from '../../mps/services/mps-user.service';
import { MpsUser } from '../models/mps-user.model';
import { ManagerEoService } from '../services/administration/manager-eo.service';

export const MpsIsAdminOrManagerEoGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userService = inject(MpsUserService);
  const managerEoService = inject(ManagerEoService);
  const loggedInUser = userService.getUser();

  if (!loggedInUser) {
    return router.createUrlTree(['/']);
  }

  const user = new MpsUser(loggedInUser);

  if (user.isAdmin()) {
    return of(true);
  }

  return managerEoService
    .checkIsManagerEo()
    .pipe(map((isManagerEo) => (isManagerEo ? true : router.createUrlTree(['/']))));
};
